import React from 'react';
import ReactDOM from 'react-dom/client';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider } from 'next-themes';
import { NativeThemeSync } from './components/common/NativeThemeSync';
import './index.css';
import './i18n/i18n';
import { router } from './router';
import { onPersistedCacheRestored, persistOptions, queryClient, startOfflineRuntime } from './lib/queryClient';

startOfflineRuntime();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem disableTransitionOnChange>
      <NativeThemeSync />
      <PersistQueryClientProvider client={queryClient} persistOptions={persistOptions} onSuccess={onPersistedCacheRestored}>
        <RouterProvider router={router} />
      </PersistQueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>
);
